import type { ReactNode } from "react";
import { StyleSheet, Text, View } from "react-native";

import { fonts, useThemedStyles, type ThemeColors } from "~/styles/theme";

/** Presentational field chrome: label, optional hint, control, error. */
export function Field({
  label,
  description,
  error,
  children,
}: {
  label: string;
  description?: string;
  error?: string;
  children: ReactNode;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <View style={stylesheet.field}>
      <Text style={stylesheet.label}>{label}</Text>
      {description ? (
        <Text style={stylesheet.description}>{description}</Text>
      ) : null}
      {children}
      {error ? (
        <Text accessibilityRole="alert" style={stylesheet.error}>
          {error}
        </Text>
      ) : null}
    </View>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    field: { gap: 6 },
    label: {
      color: colors.heading,
      fontFamily: fonts.semibold,
      fontSize: 12,
      letterSpacing: 0.2,
    },
    description: {
      color: colors.mutedForeground,
      fontFamily: fonts.regular,
      fontSize: 12,
    },
    error: {
      color: colors.danger,
      fontFamily: fonts.regular,
      fontSize: 12,
    },
  });
